import { onScopeDispose, toValue, watch } from 'vue';
import type { MaybeRefOrGetter } from 'vue';

/**
 * 在条件为真时锁定文档根滚动，避免弹窗打开时背景页面跟随滚动（含滚轮触底穿透）。
 * 条件变假或作用域销毁时自动恢复，并按滚动条宽度补偿 padding-right 防止内容横向跳动。
 */
export function useBodyScrollLock(active: MaybeRefOrGetter<boolean>) {
  const docEl = document.documentElement;
  let prevOverflow = docEl.style.overflow;
  let prevPaddingRight = docEl.style.paddingRight;
  let locked = false;

  function lock() {
    if (locked) { return; }
    prevOverflow = docEl.style.overflow;
    prevPaddingRight = docEl.style.paddingRight;
    const scrollbarWidth = window.innerWidth - docEl.clientWidth;
    docEl.style.overflow = 'hidden';
    if (scrollbarWidth > 0) {
      docEl.style.paddingRight = `${scrollbarWidth}px`;
    }
    locked = true;
  }

  function unlock() {
    if (!locked) { return; }
    docEl.style.overflow = prevOverflow;
    docEl.style.paddingRight = prevPaddingRight;
    locked = false;
  }

  watch(() => toValue(active), open => (open ? lock() : unlock()), { immediate: true });

  onScopeDispose(unlock);
}
